import React, { useRef, memo } from 'react';
import { ChevronLeft, ChevronRight, Lock } from 'lucide-react';
interface FeedFilterBarProps {
  activeFilter: string;
  setActiveFilter: (filter: string) => void;
  angelContext?: string; // Optional: Name of angel if on an angel feed
}
export const FeedFilterBar: React.FC<FeedFilterBarProps> = ({
  activeFilter,
  setActiveFilter,
  angelContext
}) => {
  const filtersRef = useRef<HTMLDivElement>(null);
  const scrollFilters = (direction: 'left' | 'right') => {
    if (filtersRef.current) {
      const scrollAmount = direction === 'left' ? -200 : 200;
      filtersRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  const filters = [{
    id: 'for_you',
    label: 'For You',
    icon: '🔥'
  }, {
    id: 'following',
    label: 'Following',
    icon: '👥'
  }, {
    id: 'highlights',
    label: 'Highlights',
    icon: '✨'
  }, {
    id: 'fan_club',
    label: angelContext ? `${angelContext}'s Club` : 'Fan Club',
    icon: '👑'
  }, {
    id: 'media',
    label: 'Videos/Photos',
    icon: '📸'
  }, {
    id: 'memory',
    label: 'Memory',
    icon: '🧠'
  }];
  return <div className="relative sticky top-0 z-10 bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm border-b border-gray-200 dark:border-gray-800" data-id="element-7628">
      <button onClick={() => scrollFilters('left')} className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white/90 dark:bg-gray-800/90 rounded-full text-of-text-secondary hover:text-of-text-primary shadow-sm" data-id="element-7629">
        <ChevronLeft size={18} data-id="element-7630" />
      </button>
      <div ref={filtersRef} className="flex overflow-x-auto py-3 px-8 scrollbar-hide" data-id="element-7631">
        {filters.map(filter => <button key={filter.id} onClick={() => setActiveFilter(filter.id)} className={`flex items-center gap-1.5 px-4 py-2 mx-1 rounded-full whitespace-nowrap transition-all ${activeFilter === filter.id ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-of-text-secondary hover:bg-gray-200 dark:hover:bg-gray-700'}`} data-id="element-7632">
            <span data-id="element-7633">{filter.icon}</span>
            <span data-id="element-7634">{filter.label}</span>
            {/* Fan Club Indicator with New Content Count */}
            {filter.id === 'fan_club' && <div className="flex items-center" data-id="element-7635">
                <span className="ml-1 px-1.5 py-0.5 bg-pink-500/20 text-pink-500 dark:bg-pink-500/30 dark:text-pink-400 text-[10px] font-medium rounded-full flex items-center" data-id="element-7636">
                  5 <Lock size={8} className="ml-0.5" data-id="element-7637" />
                </span>
                <span className="w-2 h-2 bg-pink-500 rounded-full ml-1 animate-pulse" data-id="element-7638"></span>
              </div>}
            {/* Highlights Indicator with Streak */}
            {filter.id === 'highlights' && <span className="ml-1 px-1.5 py-0.5 bg-amber-500/20 text-amber-500 dark:bg-amber-500/30 dark:text-amber-400 text-[10px] font-medium rounded-full flex items-center" data-id="element-7639">
                🔥 3
              </span>}
            {/* Media Indicator with New Content */}
            {filter.id === 'media' && <span className="ml-1 px-1.5 py-0.5 bg-blue-500/20 text-blue-500 dark:bg-blue-500/30 dark:text-blue-400 text-[10px] font-medium rounded-full" data-id="element-7640">
                +2
              </span>}
            {/* Memory Indicator */}
            {filter.id === 'memory' && <span className="ml-1 w-1.5 h-1.5 bg-purple-500 rounded-full animate-pulse" data-id="element-7641"></span>}
          </button>)}
      </div>
      <button onClick={() => scrollFilters('right')} className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white/90 dark:bg-gray-800/90 rounded-full text-of-text-secondary hover:text-of-text-primary shadow-sm" data-id="element-7642">
        <ChevronRight size={18} data-id="element-7643" />
      </button>
      <style jsx data-id="element-7644">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};